export default "__VITE_ASSET__CT_8TwbY__"